import React, { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight, Sun, Moon } from "lucide-react";
import DinnerMoonIcon from "../DinnerMoonIcon";
import LunchSunIcon from "../LunchSunIcon";

const MealInfo = ({ onClose, meals, currecy }) => {
  const [activeImg, setActiveImg] = useState(0);
  const [startIndex, setStartIndex] = useState(0);

  const visibleThumbs = 4;

  // useEffect(() => {
  //   console.log("The meals data is :", meals);
  // }, [meals]);

  const rawImages = meals?.meal_images?.map((img) => img.image_url) || [];
  const coverIndex =
    meals?.meal_images?.findIndex((img) => img.is_cover_image === 1) ?? -1;

  const orderedImages = React.useMemo(() => {
    if (!rawImages.length) return [];

    // agar cover nahi mila ya already first hai
    if (coverIndex <= 0) return rawImages;

    const coverImg = rawImages[coverIndex];
    const remainingImages = rawImages.filter(
      (_, index) => index !== coverIndex,
    );

    // cover ko first me daal do
    return [coverImg, ...remainingImages];
  }, [rawImages, coverIndex]);

  useEffect(() => {
    if (!orderedImages.length) return;

    setActiveImg((prev) => (prev >= orderedImages.length ? 0 : prev));
  }, [orderedImages]);

  const handleNext = () => {
    if (startIndex + visibleThumbs < orderedImages.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const to12Hour = (time24) => {
    if (!time24) return "";

    const [hourStr, minute] = time24.split(":");
    let hour = Number(hourStr);

    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // 0 → 12

    return `${hour}:${minute} ${ampm}`;
  };

  const dayLabels = {
    monday: "M",
    tuesday: "Tu",
    wednesday: "W",
    thursday: "Th",
    friday: "F",
    saturday: "Sa",
    sunday: "Su",
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-[2px] z-50 subpixel-antialiased
      flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* MOBILE FLOATING CLOSE */}
      <button
        onClick={onClose}
        className="sm:hidden fixed top-5 right-5 z-[999]
        bg-white rounded-full p-2 shadow-lg"
      >
        <X className="w-5 h-5 text-gray-800" />
      </button>

      {/* MODAL CARD */}
      <div
        className="
          bg-white
          w-full sm:w-[90%]
          max-w-7xl
          max-h-[90vh]
          rounded-2xl
          shadow-2xl
          overflow-hidden
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h2 className="text-base sm:text-lg font-semibold text-gray-800">
            Meal Info
          </h2>

          {/* DESKTOP CLOSE */}
          <button onClick={onClose} className="hidden sm:flex">
            <X className="w-5 h-5 text-gray-600 hover:text-black" />
          </button>
        </div>

        {/* CONTENT (SCROLLS INSIDE MODAL) */}
        <div className="overflow-y-auto max-h-[75vh]">
          <div className="flex flex-col lg:flex-row gap-5 p-4 sm:p-6">
            {/* LEFT : IMAGE GALLERY */}
            <div className="w-full md:w-[45%] space-y-3 p-8 md:p-2">
              {/* MAIN IMAGE */}
              <div className="rounded-2xl p-[5px] bg-gradient-to-tr from-orange-600 via-white to-orange-300 shadow-[0_0_20px_rgba(255,140,0,0.35)] transition-transform">
                <div className="rounded-xl bg-white overflow-hidden aspect-square sm:aspect-[1/1]">
                  <img
                    src={orderedImages[activeImg]}
                    // src={meals.meal_cover_image}
                    alt="meal"
                    className="w-full aspect-square object-cover hover:scale-[1.02] transition-transform duration-300"
                  />
                </div>
              </div>

              {/* THUMBNAILS */}
              <div className="relative">
                {startIndex > 0 && (
                  <button
                    onClick={handlePrev}
                    className="absolute -left-3 top-1/2 -translate-y-1/2
                    bg-white shadow-md rounded-full p-1 z-10"
                  >
                    <ChevronLeft size={16} />
                  </button>
                )}

                <div className="flex justify-center gap-2">
                  {orderedImages
                    .slice(startIndex, startIndex + visibleThumbs)
                    .map((img, i) => {
                      const index = startIndex + i;
                      return (
                        <img
                          key={index}
                          src={img}
                          onClick={() => setActiveImg(index)}
                          className={`w-16 h-16 rounded-lg cursor-pointer border object-cover
          ${
            activeImg === index
              ? "border-2 border-[#FF6943] opacity-100 rotate-6"
              : "border-gray-200 opacity-80"
          }`}
                        />
                      );
                    })}
                </div>

                {startIndex + visibleThumbs < orderedImages.length && (
                  <button
                    onClick={handleNext}
                    className="absolute -right-3 top-1/2 -translate-y-1/2
                    bg-white shadow-md rounded-full p-1 z-10"
                  >
                    <ChevronRight size={16} />
                  </button>
                )}
              </div>
            </div>

            {/* RIGHT : INFO */}
            <div className="flex-1 flex flex-col   items-start space-y-3">
              <h3 className="text-3xl font-semibold text-gray-800">
                {meals?.meal_name}
              </h3>

              <p className="text-sm text-gray-600 leading-relaxed max-w-sm">
                {meals?.meal_description}
              </p>

              <div className="flex items-center gap-2 text-sm">
                <span className="text-gray-900 font-semibold">Price</span>
                <span className="font-bold text-[#FF6943]">
                  {currecy} {meals?.trial_serving_cost} / Meal
                </span>
              </div>
              <div className="mt-4">
                <p className="text-gray-900 font-semibold text-sm mb-2">
                  Cut off time
                </p>
                <div className="flex flex-row gap-4 md:gap-6 border border-[#FECDC1] rounded-2xl bg-white p-4 w-full md:w-96">
                  {/* Card 1: Lunch */}
                  <div className="flex flex-col gap-1 flex-1 space-y-2">
                    <div className="flex items-center gap-1 font-semibold text-orange text-lg">
                      <LunchSunIcon className="w-5 h-5" /> Lunch
                    </div>

                    <p className="text-xs text-[#191919]">
                      Cutoff Time: {meals?.lunch_cutoff_time}
                    </p>
                  </div>

                  {/* Divider */}
                  <div className="w-px bg-[#FECDC1]" />

                  {/* Card 2: Dinner */}
                  <div className="flex flex-col gap-1 flex-1 space-y-2">
                    <div className="flex items-center gap-1 font-semibold text-orange text-lg">
                      <DinnerMoonIcon className="w-5 h-5" /> Dinner
                    </div>

                    <p className="text-xs text-[#191919]">
                      Cutoff Time: {meals?.dinner_cutoff_time}
                    </p>
                  </div>
                </div>
              </div>

              {/* DAYS */}
              <div className="mt-6">
                <div className="flex gap-1 flex-wrap">
                  {meals?.availability_data.map((day) => {
                    const base =
                      "relative w-[18px] h-[18px] md:w-6 md:h-6 text-[12px] font-medium rounded-md flex items-center justify-center overflow-hidden";

                    if (day.isLunch && day.isDinner) {
                      return (
                        <span
                          key={day.key}
                          className={`${base} bg-[#B472FF] text-white
            after:content-['']
            after:absolute
            after:inset-0
            after:rounded-md
            after:bg-[#FF6943]
            after:[clip-path:polygon(100%_0,100%_100%,0_100%)]
          `}
                          title="Lunch + Dinner"
                        >
                          <span className="relative z-10">
                            {dayLabels[day.key]}
                          </span>
                        </span>
                      );
                    }

                    if (day.isLunch) {
                      return (
                        <span
                          key={day.key}
                          className={`${base} bg-[#B472FF] text-white`}
                          title="Lunch"
                        >
                          {dayLabels[day.key]}
                        </span>
                      );
                    }

                    if (day.isDinner) {
                      return (
                        <span
                          key={day.key}
                          className={`${base} bg-[#FF6943] text-white`}
                          title="Dinner"
                        >
                          {dayLabels[day.key]}
                        </span>
                      );
                    }

                    return (
                      <span
                        key={day.key}
                        className={`${base} bg-gray-100 text-[#303030]`}
                        title="Not available"
                      >
                        {dayLabels[day.key]}
                      </span>
                    );
                  })}
                </div>
              </div>

              {/* PLAN PRICING */}
              <div className="space-y-2 pt-2">
                <h4 className="font-semibold text-gray-800 text-sm">
                  Plan Pricing
                </h4>

                <div className="border border-gray-200 rounded-xl p-4 max-h-64 sm:max-h-72 md:max-h-80 overflow-y-auto grid grid-cols-2 gap-3">
                  {/* Trial Plan */}
                  <div className="px-4 py-2 rounded-full bg-gray-100 border flex justify-between items-center min-w-[140px] flex-wrap">
                    <span className="text-xs font-medium subpixel-antialiased">
                      Trial (1 day)
                    </span>
                    <span className="ml-2 font-bold text-orange">
                      {currecy}
                      {Number(meals?.trial_serving_cost).toFixed(2)}
                    </span>
                  </div>

                  {/* Weekly Plans */}
                  {meals?.weekly_plans?.map((plan) => {
                    const totalCount =
                      Number(plan.order_count) *
                      Number(meals.trial_serving_cost);

                    // console.log("The totalCount is:", totalCount);

                    return (
                      <div
                        key={plan.meal_plan_id}
                        className="px-4 py-2 rounded-full bg-gray-100 border flex justify-between items-center min-w-[140px] flex-wrap"
                      >
                        <span className="text-xs font-medium subpixel-antialiased">
                          Weekly ({plan.order_count} days)
                        </span>

                        <span className="ml-2 font-bold text-orange">
                          {currecy}
                          {Number(totalCount).toFixed(2)}
                        </span>

                        {/* Optional: show calculated amount */}
                        {/* <span>Calculated: ₹{totalCount}</span> */}
                      </div>
                    );
                  })}
                  {meals?.monthly_plans?.map((mPlan) => {
                    const totalCount =
                      Number(mPlan.order_count) *
                      Number(meals.trial_serving_cost);

                    // console.log("The totalCount is:", totalCount);

                    return (
                      <div
                        key={mPlan.meal_plan_id}
                        className="px-4 py-2 rounded-full bg-gray-100 border flex justify-between items-center min-w-[140px] flex-wrap"
                      >
                        <span className="text-xs font-medium subpixel-antialiased">
                          Montly ({mPlan.order_count} days)
                        </span>

                        <span className="ml-2 font-bold text-orange">
                          {currecy}
                          {Number(totalCount).toFixed(2)}
                        </span>

                        {/* Optional: show calculated amount */}
                        {/* <span>Calculated: ₹{totalCount}</span> */}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="px-5 py-3 border-t flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 bg-[#FF6943] text-white rounded-lg text-sm hidden md:block"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MealInfo;
